const DoneIcon = () => (
  <svg width="108" height="108" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="53.625" cy="53.625" r="52.125" stroke="currentColor" strokeWidth="3" />
    <path d="M36.5625 54.8438L48.3844 67.0312L74.3438 36.5625" stroke="currentColor" strokeWidth="3" />
  </svg>
);

export default DoneIcon;
